<template>
    <div class="password-recovery__container">
        <template v-if="isSuccess">
            <div class="modal__header mb-6">
                <h6 class="modal__title">{{  $t('success') | capitalize }}</h6>
            </div>
            <Illustration xl image="/static/img/illustrations/password-recovery__success.svg"/>
            <div class="instruction mb-4">
                {{ $t('Your password has been updated successfully. Now you can sign in with your new credentials.') }}
            </div>
            <button
                class="btn btn__primary btn__primary--green btn--block"
                @click="signIn"
            >
                {{ $t('login') | upperCase }}
            </button>
        </template>
        <template v-else>
            <div class="modal__header mb-6">
                <h6 class="modal__title">{{  $t('password reset') | capitalize }}</h6>
            </div>
            <div class="instruction mb-6">
                {{ $t(`Please enter a new password and confirm your changes.`) }}
            </div>
            <GenericForm
                :fields="fields"
                @submit="onSave"
            >
                <template slot-scope="slotProps">
                    <Password
                        :label="$t('New Password')"
                        name="password"
                        v-model="fields.password.value"
                        :errorMessage="slotProps.errors.password"
                        @valueChanged="slotProps.onValueChanged"
                        ref="password"
                    />
                    <div
                        class="message message--error mb-4"
                        v-if="error"
                    >
                        {{ error }}
                    </div>
                    <CustomButton
                        :isLoading="isLoading"
                        type="submit"
                        class="btn btn__primary btn--block"
                    >
                        {{ $t('confirm reset') | upperCase }}
                    </CustomButton>
                </template>
            </GenericForm>
        </template>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { authenticationService } from '@core/services/authentication/AuthenticationService';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import ValidationError from '@core/errors/network/ValidationError';
    import MalformedDataError from '@core/errors/network/MalformedDataError';
    import { routeNames } from '@app/router';
    import config from '@config';
    import { minLength, isRequired } from '@modules/shared/validators/forms';
    import { errorGuard } from '@app/utils';

    export default {
        name: 'ChangeForgotPasswordContainer',
        data() {
            return {
                isLoading: false,
                isSuccess: false,
                fields: {
                    password: {
                        value: null,
                        validate: [
                            isRequired,
                            minLength(config.app.auth.passwordMinLength)
                        ]
                    },
                },
                asyncErrors: {},
                error: '',
            };
        },
        mounted() {
            this.$refs.password.focusInput();
        },
        watch: {
            user(newValue) {
                if (newValue) {
                    this.goToLanding();
                }
            },
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', ['setModal']),
            ...mapActions('errors', [
                'showError',
            ]),
            async onSave() {
                this.isLoading = true;
                this.error = '';
                this.asyncErrors = {};
                await errorGuard({
                    action: async () => {
                        await authenticationService.changeForgottenPassword(
                            this.$router.currentRoute.query.passwordToken,
                            this.fields.password.value
                        );
                        this.isSuccess = true;
                    },
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else if (e instanceof MalformedDataError) {
                            this.error = e.message;
                        } else {
                            this.showError(e);
                        }
                    },
                });
                this.isLoading = false;
            },
            goToLanding() {
                this.$router.replace({
                    name: routeNames.landing,
                });
            },
            signIn() {
                this.setModal(Modals.login);
                this.goToLanding();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/authentication/PasswordRecoveryContainer.vue